export default __webpack_public_path__ + "static/media/icon-survey-red.2c338511.png";